<template>
  <!--  -->
  <div class="min-h-screen flex-1 mt-1 bg-gray-100 px-4 pt-12 shadow-lg items-center">
    <!--  -->
    <div class="bg-white w-fullrounded-lg shadow">
      <!--  -->
      <div class="h-20 py-3 flex items-center border-gray-200 p-6 mt-2">
        <!--  -->
        <div class="flex">
          <!--  -->
          <router-link :class="$colors.primary" class="rounded-full flex justify-center items-center w-8 h-8 mt-1 mr-3"
            to="/roles">
            <!--  -->
            <i class="material-icons mx-2">chevron_left</i>
            <!--  -->
          </router-link>
          <!--  -->

          <!--  -->
          <div v-if="!formData._id" class="text-2xl font-bold text-primary-500">
            {{ $t('new_role') }}
          </div>
          <!--  -->

          <!--  -->
          <div v-else class="text-2xl font-bold text-primary-500">
            {{ $t('edit_role') }}
          </div>
          <!--  -->
        </div>
        <!--  -->
      </div>
      <!--  -->

      <!--  -->
      <div class="">
        <!--  -->
        <div class="bg-white rounded-lg p-6 pt-2">
          <!--  -->
          <div class="grid lg:grid-cols-2 gap-6">
            <!--  -->
            <div
              class="border hover:border-orange-500 focus-within:border-orange-500 focus-within:text-primary-500 transition-all duration-500 relative rounded p-1">
              <!--  -->
              <div class="-mt-4 absolute tracking-wider px-1 capitalize text-xs">
                <!--  -->
                <p>
                  <!--  -->
                  <label for="name" class="bg-white text-gray-700 px-1">{{ $t('name') }}
                    <!--  -->
                    <span :class="$colors.required">*</span>
                    <!--  -->
                  </label>
                  <!--  -->
                </p>
                <!--  -->
              </div>
              <!--  -->

              <!--  -->
              <p>
                <!--  -->
                <input id="name" autocomplete="false" tabindex="0" type="text" v-model="formData.name"
                  class="py-2 text-xs px-2 outline-none block h-full w-full" />
                <!--  -->
              </p>
              <!--  -->
            </div>
            <!--  -->

            <!--  -->
            <div
              class="border hover:border-orange-500 focus-within:border-orange-500 focus-within:text-primary-500 transition-all duration-500 relative rounded p-1">
              <!--  -->
              <div class="-mt-4 absolute tracking-wider px-1 capitalize text-xs">
                <!--  -->
                <p>
                  <!--  -->
                  <label for="description" class="bg-white text-gray-700 px-1">{{ $t('description') }}</label>
                  <!--  -->
                </p>
                <!--  -->
              </div>
              <!--  -->

              <!--  -->
              <p>
                <!--  -->
                <input id="description" autocomplete="false" tabindex="0" type="text" v-model="formData.description"
                  class="py-2 text-xs px-2 outline-none block h-full w-full" />
                <!--  -->
              </p>
              <!--  -->
            </div>
            <!--  -->
          </div>
          <!--  -->

          <!--  -->
          <div
            class="border hover:border-orange-500 mt-4 px-4 w-full focus-within:border-orange-500 focus-within:text-primary-500 transition-all duration-500 relative rounded p-1">
            <!--  -->
            <div class="-mt-4 absolute tracking-wider px-1 capitalize text-xs">
              <!--  -->
              <p>
                <!--  -->
                <label for="description" class="bg-white text-gray-700 px-1">{{ $t('permissions') }}
                  <!--  -->
                  <span :class="$colors.required">*</span>
                  <!--  -->
                </label>
                <!--  -->
              </p>
              <!--  -->
            </div>
            <!--  -->

            <!--  -->
            <div class="">
              <!--  -->
              <div class="w-full mt-2">
                <!--  -->
                <table class="table w-full text-center">
                  <!--  -->
                  <thead class="bg-gray-100 text-black">
                    <!--  -->
                    <tr>
                      <!--  -->
                      <th
                        class="px-5 py-2 border-gray-200 text-left text-xs font-semibold text-gray-700 capitalize tracking-wider">
                        {{ $t('model') }}
                      </th>
                      <!--  -->

                      <!--  -->
                      <th
                        class="px-5 py-2 border-gray-200 text-left text-xs font-semibold text-gray-700 capitalize tracking-wider">
                        {{ $t('create') }}
                      </th>
                      <!--  -->

                      <!--  -->
                      <th
                        class="px-5 py-2 border-gray-200 text-left text-xs font-semibold text-gray-700 capitalize tracking-wider">
                        {{ $t('Watch') }}
                      </th>
                      <!--  -->

                      <!--  -->
                      <th
                        class="px-5 py-2 border-gray-200 text-left text-xs font-semibold text-gray-700 capitalize tracking-wider">
                        {{ $t('read') }}
                      </th>
                      <!--  -->

                      <!--  -->
                      <th
                        class="px-5 py-2 border-gray-200 text-left text-xs font-semibold text-gray-700 capitalize tracking-wider">
                        {{ $t('update') }}
                      </th>
                      <!--  -->

                      <!--  -->
                      <th
                        class="px-5 py-2 border-gray-200 text-left text-xs font-semibold text-gray-700 capitalize tracking-wider">
                        {{ $t('delete') }}
                      </th>
                      <!--  -->
                    </tr>
                    <!--  -->
                  </thead>
                  <!--  -->
                  <tbody>
                    <!--  -->
                    <tr v-for="(el, index) in filteredModules" :key="index"
                      :class="index % 2 == 0 ? 'bg-gray-100' : ''">
                      <!--  -->
                      <td class="px-5 py-2 pt-3 text-left border-gray-200 bg-white text-sm">
                        <!--  -->
                        <p class="text-gray-700 capitalize">{{ el.model }}</p>
                        <!--  -->
                      </td>
                      <!--  -->

                      <!--  -->
                      <td class="px-5 py-2 pt-3 text-left border-gray-200 bg-white text-sm">
                        <!--  -->
                        <p class="text-gray-600 ml-3 text-semibold capitalize">
                          <!--  -->
                          <label class="inline-flex text-sm items-center capitalize">
                            <!--  -->
                            <input v-model="el.access.create" type="checkbox" :class="[
                              'form-checkbox h-4 w-4',
                              { 'disabled': isDisabledForSeller(el.model, 'create') }
                            ]" :disabled="isDisabledForSeller(el.model, 'create')" />
                            <!--  -->
                          </label>
                          <!--  -->
                        </p>
                        <!--  -->
                      </td>
                      <!--  -->

                      <!--  -->
                      <td class="px-5 py-2 pt-3 text-left border-gray-200 bg-white text-sm">
                        <!--  -->

                        <!--  -->
                        <p class="text-gray-600 ml-3 text-semibold capitalize">
                          <!--  -->
                          <label class="inline-flex text-sm items-center capitalize">
                            <!--  -->
                            <input v-model="el.access.watch" type="checkbox" :class="[
                              'form-checkbox h-4 w-4',
                              { 'disabled': isDisabledForSeller(el.model, 'watch') }
                            ]" :disabled="isDisabledForSeller(el.model, 'watch')" />
                            <!--  -->
                          </label>
                          <!--  -->
                        </p>
                        <!--  -->
                      </td>
                      <!--  -->

                      <!--  -->
                      <td class="px-5 py-2 pt-3 text-left border-gray-200 bg-white text-sm">
                        <!--  -->
                        <p class="text-gray-600 ml-2 text-semibold capitalize">
                          <!--  -->
                          <label class="inline-flex text-sm items-center capitalize">
                            <!--  -->
                            <input v-model="el.access.read" type="checkbox" :class="[
                              'form-checkbox h-4 w-4',
                              { 'disabled': isDisabledForSeller(el.model, 'read') }
                            ]" :disabled="isDisabledForSeller(el.model, 'read')" />
                            <!--  -->
                          </label>
                          <!--  -->
                        </p>
                        <!--  -->
                      </td>
                      <!--  -->

                      <!--  -->
                      <td class="px-5 py-2 pt-3 text-left border-gray-200 bg-white text-sm">
                        <!--  -->
                        <p class="text-gray-600 ml-3 text-semibold capitalize">
                          <!--  -->
                          <label class="inline-flex text-sm items-center capitalize">
                            <!--  -->
                            <input v-model="el.access.update" type="checkbox" :class="[
                              'form-checkbox h-4 w-4',
                              { 'disabled': isDisabledForSeller(el.model, 'update') }
                            ]" :disabled="isDisabledForSeller(el.model, 'update')" />
                            <!--  -->
                          </label>
                          <!--  -->
                        </p>
                        <!--  -->
                      </td>
                      <!--  -->

                      <!--  -->
                      <td class="px-5 py-2 pt-3 text-left border-gray-200 bg-white text-sm">
                        <!--  -->
                        <p class="text-gray-600 ml-3 text-semibold capitalize">
                          <!--  -->
                          <label class="inline-flex text-sm items-center capitalize">
                            <!--  -->
                            <input v-model="el.access.delete" type="checkbox" :class="[
                              'form-checkbox h-4 w-4',
                              { 'disabled': isDisabledForSeller(el.model, 'delete') }
                            ]" :disabled="isDisabledForSeller(el.model, 'delete')" />
                          </label>
                          <!--  -->
                        </p>
                        <!--  -->
                      </td>
                      <!--  -->
                    </tr>
                    <!--  -->
                  </tbody>
                  <!--  -->
                </table>
                <!--  -->
              </div>
              <!--  -->
            </div>
            <!--  -->
          </div>
          <!--  -->

          <!--  -->
          <div class="mt-6 pt-3 flex justify-center">
            <!--  -->
            <button
              class="rounded focus:outline-none outline-none text-gray-100 px-3 w-1/6 py-2 bg-primary-600 hover:shadow-inner hover:bg-primary-700 transition-all duration-300"
              @click="save">
              {{ $t('save') }}
            </button>
            <!--  -->
          </div>
          <!--  -->
        </div>
        <!--  -->
      </div>
      <!--  -->
    </div>
    <!--  -->
  </div>
  <!--  -->
</template>

<script>
export default {
  data() {
    return {
      formData: {},
      modules: [],
      types: [
        'Seller',
        'TeleConsultant',
        'StockManager',
        'Courier',
        'Accountant',
        'Admin',
      ],
      currentUser: {
        role: {},
      },
      sellerModules: [
        'products',
        'orders',
        'expeditions',
        'shippings',
        'payments',
        'settings',
        'groups',
        'status',
        'users',
        'zones',
        'warehouses',
        'chat',
      ],
      readOnlyModules: ['status', 'users', 'zones', 'warehouses'],
      noUpdateModules: ['orders', 'shippings', 'payments'],
      noCreateModules: ['shippings', 'payments', 'settings', 'groups'],
      noWatchModules: ['groups'],
    };
  },
  computed: {
    isSeller() {
      return this.currentUser.type === 'Seller';
    },
    filteredModules() {
      if (this.isSeller) {
        return this.modules.filter(module =>
          this.sellerModules.includes(module.model),
        );
      }
      return this.modules;
    },
  },
  async mounted() {
    await this.fetchUser();
    await this.dataToEdit();
    if(!this.formData._id) {
      this.setModules();
    }
  },
  methods: {
    isDisabledForSeller(model, action) {
      if (!this.isSeller) return false;

      if (action === 'delete') return true;

      if (action === 'create' && this.noCreateModules.includes(model)) {
        return true;
      }

      if (action === 'watch' && this.noWatchModules.includes(model)) {
        return true;
      }

      if (this.readOnlyModules.includes(model)) {
        return action !== 'read';
      }

      if (this.noUpdateModules.includes(model) && action === 'update') {
        return true;
      }

      return false;
    },
    async fetchUser() {
      try {
        const { content } = await this.$server.me('users');
        this.currentUser = content || {};
      } catch (error) {
        console.error('Failed to fetch user:', error);
        this.currentUser = {};
      }
    },
    async save() {
      this.formData.permissions = this.modules;

      if (this.formData._id) {
        const { _id } = await this.$server.update('roles', this.formData);

        if (_id) {
          alert(this.$t('role_updated'), 'success');
        }
      } else {
        if (!this.checkData()) {
          alert(this.$t('all_required_field'), 'warning');
          return;
        }

        if (this.currentUser !== 'CEO' && !this.formData.userRole) {
          this.formData.userRole = this.currentUser;
          this.formData.type = 'SubUser';
        }

        const { _id } = await this.$server.create('roles', this.formData);

        if (_id) {
          alert(this.$t('role_created'), 'success');
          this.resetFormData();

          if (localStorage.getItem('User_email')) {
            localStorage.setItem('Role', JSON.stringify({ _id }));
            this.$router.push('/users/new');
          }
        }
      }
    },
    checkData() {
      return !!this.formData.name;
    },
    setModules() {
      const defaultAccess = {
        create: false,
        read: false,
        update: false,
        delete: false,
        watch: false,
      };

      this.modules = [];

      const models = this.isSeller
        ? this.sellerModules
        : [
            'categories',
            'expeditions',
            'internalexpeditions',
            'orders',
            'payments',
            'products',
            'roles',
            'shippings',
            'status',
            'statusHistories',
            'stockHistories',
            'shippingsHistories',
            'subscribers',
            'users',
            'userHistories',
            'zones',
            'teams',
            'settings',
            'analytics',
            'warehouses',
            'cashflow',
            'groups',
            'chat',
          ];

      models.forEach(model => {
        const access = { ...defaultAccess };
        this.modules.push({
          model,
          access,
        });
      });
    },
    async dataToEdit() {
      if (!this.$route.params.id) return;

      const { content } = await this.$server.get('roles', {
        id: this.$route.params.id,
      });

      this.formData = content;
      this.modules = content.permissions || [];

      const additionalModules = this.isSeller ?
      [
        'groups'
      ] : [
        'warehouses',
        'shippingsHistories',
        'settings',
        'analytics',
        'userHistories',
        'internalexpeditions',
        'cashflow',
        'groups',
        'chat',
      ];

      additionalModules.forEach(module => {
        this.addElementArray(
          {
            model: module,
            access: {
              create: false,
              read: false,
              update: false,
              delete: false,
              watch: false,
            },
          },
          this.modules,
        );
      });
    },
    addElementArray(element, array) {
      const exists = array.some(e => e.model === element.model);
      if (!exists) {
        array.push(element);
      }
    },
    resetFormData() {
      this.formData = {};
      this.setModules();
    },
    
  },
};
</script>

<style scoped>
.icon::after {
  content: '';
  display: block;
  position: absolute;
  border-top: 23px solid transparent;
  border-bottom: 17px solid transparent;
  border-left: 12px solid #3182ce;
  left: 100%;
  top: 0;
}

.form-checkbox.disabled {
  border-color: #ff4444;
  background-color: #ffcccc;
  opacity: 0.7;
}
</style>
